// extracted by mini-css-extract-plugin
export default {"selectorListItem":"Printer_selectorListItem__mq1mP"};